<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, aieModal }">
      <v-btn
        x-large
        elevation="3"
        class="ma-2"
        color="primary"
        v-bind="aieModal"
        v-on="on"
        >Click Me</v-btn
      >
    </template>
    <v-card elevation="3" class="modal-card">
      <v-card-title>
        <h3>Project Overview</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <hr />
      </v-card-title>
      <div class="modal-img">
        <img
          src="@/assets/images/featured-projects/aie-training.jpg"
          alt="SDP"
        />
      </div>
      <div class="project-info">
        <h1>AIE Dental Implant Training</h1>
        <p>
          Responsive Website for AIE's Dental Implant Training Programs. Their
          programs allow the practicing professionals to serve patients in the
          best possible way. Training and education have a supreme value for
          medical practitioners, as learning should never stop.
        </p>
        <ul class="details">
          <li><label>Client:</label>Lasso Digital</li>
          <li><label>Category:</label>Web Development</li>
          <li><label>Role:</label>Developer</li>
          <li>
            <label>Project URL:</label
            ><a target="_blank" href="https://dentalimplanttrainingce.com/"
              >DentalImplantTrainingCE.com</a
            >
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
</style>